import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import LocalPizzaOutlinedIcon from '@mui/icons-material/LocalPizzaOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import { FC, useState } from 'react';
import { useApiVersion } from '../../services/navigation/navigation.service';
import Logo from '../Logo/Logo';
import { LogoContainer, NavigationContainer, SkipNav, VersionsContainer } from './Navigation.styles';
import NavigationLink from './NavigationLink/NavigationLink';
import FeatureFlags from '../../constants/FeatureFlags';
import { useFeatureFlag } from '../../services/optimizely/optimizelyHooks';

const Navigation: FC = () => {
  /* We will need to include a focusable element with the id of `skipNavTarget` on each page for this to function */
  const handleSkipNav = () => {
    document.getElementById('skipNavTarget')?.focus();
  };

  const { isEnabled: bulkUpdatesEnabled } = useFeatureFlag(FeatureFlags.BULK_UPDATE_ENABLED);
  const [refetchCount, setRefetchCount] = useState(0);
  const { data: apiVersion } = useApiVersion(refetchCount, setRefetchCount);
  const uiVersion = process.env.REACT_APP_UI_VERSION;

  return (
    <NavigationContainer data-testid='navigation' aria-label='Operations UI'>
      <SkipNav label='Skip to main content' onClick={handleSkipNav} />
      <LogoContainer to='/tables'>
        <Logo />
      </LogoContainer>
      <NavigationLink
        to='/dashboard'
        label='Dashboard'
        icon={<DashboardOutlinedIcon />}
        testId='leftPanelDashboard'
        offset={1}
      />
      <NavigationLink
        to='/tables'
        label='Tables'
        icon={<TableViewOutlinedIcon />}
        testId='leftPanelTables'
        offset={2}
      />
      <NavigationLink
        label='Option Recipes'
        icon={<LocalPizzaOutlinedIcon />}
        to='/optionrecipes'
        offset={3}
        letterSpacing={'-0.2px'}
        testId='leftPanelOptRecipes'
      />
      <NavigationLink
        label='Recipes'
        icon={<GridViewOutlinedIcon />}
        to='/recipes'
        offset={4}
        testId='leftPanelRecipes'
      />
      {bulkUpdatesEnabled && (
        <NavigationLink
          label='Bulk Updates'
          icon={<BuildOutlinedIcon />}
          to='/bulk-updates'
          offset={5}
          testId='leftPanelBulkUpdates'
        />
      )}
      <NavigationLink label='Menus' icon={<MenuBookOutlinedIcon />} to='/menus' offset={5} testId='leftPanelMenus' />
      <NavigationLink
        label='Store Control'
        icon={<StoreOutlinedIcon />}
        to='/storecontrol'
        offset={6}
        testId='leftPanelStoreControl'
      />
      <NavigationLink
        label='Extract'
        icon={<DownloadOutlinedIcon />}
        to='/extract'
        offset={7}
        testId='leftPanelExtracts'
      />
      <NavigationLink
        label='Publish'
        icon={<PublishOutlinedIcon />}
        to='/publish'
        testId='leftPanelPublish'
        offset={8}
      />
      <VersionsContainer>
        {(apiVersion || uiVersion) && (
          <h3>
            API: {apiVersion?.data.build.version || ''} <br />
            UI: {uiVersion}
          </h3>
        )}
      </VersionsContainer>
    </NavigationContainer>
  );
};

export default Navigation;
